import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const ResultsList = ({ items, baseUrl, nameHeader = 'Naam' }) => {
  const [sortBy, setSortBy] = useState('naam');
  
  const sortedItems = Object.entries(items).sort((a, b) => {
    if (sortBy === 'count') {
      return b[1].count - a[1].count;
    }
    // Sort by displayName if available, otherwise by key
    const aName = items[a[0]].displayName || a[0];
    const bName = items[b[0]].displayName || b[0];
    return aName.localeCompare(bName);
  });

  return (
    <>
      <div className="sort">
        <div>Sorteer op:</div>
        <div>
          <button 
            className={sortBy === 'count' ? 'active' : ''} 
            onClick={() => setSortBy('count')}
          >
            Aantal
          </button>
        </div>
        <div>
          <button 
            className={sortBy === 'naam' ? 'active' : ''} 
            onClick={() => setSortBy('naam')}
          >
            {nameHeader}
          </button>
        </div>
      </div>
      
      <div className="schools_container">
        <table className="schools">
          <thead>
            <tr>
              <th>{nameHeader}</th>
              <th>Kinderen</th>
            </tr>
          </thead>
          <tbody>
            {sortedItems.map(([key, data]) => (
              <tr key={key}>
                <td>
                  {baseUrl === null ? (
                    <span>{data.displayName || key}</span>
                  ) : baseUrl !== undefined ? (
                    <Link to={`${baseUrl}/${encodeURIComponent(key)}`}>
                      {data.displayName || key} <img src="/link_arrow.svg" alt="arrow" />
                    </Link>
                  ) : (
                    <Link to={`/${encodeURIComponent(key)}`}>
                      {data.displayName || key} <img src="/link_arrow.svg" alt="arrow" />
                    </Link>
                  )}
                </td>
                <td>{data.count}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default ResultsList;